import { Grid, Paper, Tooltip } from "@mui/material";
import React from "react";
import { connect } from "react-redux";
import { CheckInOutJson } from "../../DynamicFormsJson/MastersJSON/checkInOut";
import { getBelowSalesTeamList, getSalesExecutiveByUserType } from "../../Slice/salesExecutive.slice";
import { ButtonCompo } from "../../components/Comman/Button";
import LandingScreenHeader from "../../components/Comman/LandingScreenHeader";
import DynamicFormWithoutSave from "../../components/dynamicscreens/DynamicFormWithoutSave";
import endpoint from "../../config/endpoints";
import { checkedListEmptyMsg, deletemsg, deleteWarningMsg, noInternetMsg, pleaseAllowLocationMsg, pleaseSelectCheckInAndCheckOutTimeMsg, saveFailedMsg, savemsg, saveWarningMsg, serverMsg, youAreOnApprovedLeaveMsg } from "../../config/messageconstant";
import { apiGet, apiPost } from "../../utils/api_service";
import { showLoador, showNotification } from "../Landing/Landing.slice";

class CheckInOut extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {
                salesPersonDetail: this.props.salesPersonList?.salesPersonByArea,
            },
            searchValue: "",
            salesTeamId: "",
            fromDate: "",
            toDate: "",
            matrixData: {},
            selectedRecords: [],
            latitute: "",
            longitute: "",
            address: "",
            selectedKeys: [],
        };
    }

    async componentDidMount() {
        const { getSalesExecutiveByUserType, getBelowSalesTeamList, showLoador, showNotification } =
            this.props;
        if (navigator.onLine) {
            const userTypeId = localStorage.getItem("userTypeId");

            if (userTypeId && userTypeId == 1) {
                showLoador({ loador: true });
                await getSalesExecutiveByUserType({ userTypeId: "3,4" }).then(
                    ({ success, response }) => {
                        showLoador({ loador: false });
                        if (!success) {
                            showNotification({ msg: serverMsg, severity: "error" });
                        }
                    }
                );
            } else if (userTypeId && userTypeId == 3) {
                showLoador({ loador: true });
                await getBelowSalesTeamList({ salesTeamId:"", flag: "1" }).then(
                    ({ success, response }) => {
                        showLoador({ loador: false });
                        if (!success) {
                            showNotification({ msg: serverMsg, severity: "error" });
                        }else{
                            this.setState({
                                dynamicMasterData: {
                                    ...this.state.dynamicMasterData,
                                    salesPersonDetail: response,
                                },
                            });
                        }
                    }
                );
            }

            this.getCurrentLocationData();

        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }
    componentWillReceiveProps(nextProps) {
        if (this.props.salesPersonList !== nextProps.salesPersonList) {
            if (
                this.props.salesPersonList?.salesPersonByArea !==
                nextProps.salesPersonList?.salesPersonByArea
            ) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        salesPersonDetail: nextProps.salesPersonList?.salesPersonByArea,
                    },
                });
            }
        }
    }

    getCurrentLocationData = () => {
        const success = (position) => {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            this.setState({
                latitute: latitude,
                longitute: longitude,
            });
            return { latitute: latitude, longitute: longitude };
        };

        const error = () => {
            console.log("Unable to retrieve your location");
            return "";
        };

        navigator.geolocation.getCurrentPosition(success, error);
    };

    onSearch = async (data) => {
        const { showLoador, showNotification } = this.props;
        if (navigator.onLine) {

            this.setState({
                fromDate: data.fromDate,
                toDate: data.toDate,
                salesTeamId: data.salesTeamId,
            });
            showLoador({ loador: true });
            await apiGet({
                url:
                    endpoint.checkInOut + "/with-sales-team-and-date?salesTeamId="
                    + data.salesTeamId + "&fromDate=" + data.fromDate + "&toDate=" + data.toDate,
            }).then(({ data, success }) => {
                showLoador({ loador: false });
                if (!success) {
                    showNotification({ msg: serverMsg, severity: "error", });
                } else {
                    if (Object.keys(data.data).length !== 0) {

                        const matrixData = data.data;

                        if (matrixData.salesTeamCheckInOut) {
                            const updatedSalesTeamCheckInOut = matrixData.salesTeamCheckInOut.map((dataObj) => {
                                return {
                                    ...dataObj,
                                    checkInTime: dataObj.checkInTime ? dataObj.checkInTime.split(" ")[1] : null,
                                    checkOutTime: dataObj.checkOutTime ? dataObj.checkOutTime.split(" ")[1] : null,
                                };
                            });

                            this.setState({
                                matrixData: {
                                    ...matrixData,
                                    salesTeamCheckInOut: updatedSalesTeamCheckInOut,
                                },
                                selectedRecords: [],
                            });
                        }
                    }
                }
            });
        } else {
            this.props.showNotification({ msg: noInternetMsg, severity: "error" });
        }
    };

    toggleRecordSelection = (salesTeamId, date) => {
        const { selectedRecords, matrixData } = this.state;
        const { salesTeamCheckInOut } = matrixData;

        const record = salesTeamCheckInOut.find(
            (item) => item.salesTeamId == salesTeamId && item.date == date
        );

        if (!record) return;

        if (record.flag == 3) return;

        const checkInMissing = !record.checkInTime;
        const checkOutMissing = !record.checkOutTime;

        if (checkInMissing && checkOutMissing) {
            this.props.showNotification({
                msg: pleaseSelectCheckInAndCheckOutTimeMsg,
                severity: "error",
            });
            return;
        }

        const alreadySelected = selectedRecords.some(
            (r) => r.salesTeamId === salesTeamId && r.date === date
        );

        let updatedSelection;
        if (alreadySelected) {
            updatedSelection = selectedRecords.filter(
                (r) => !(r.salesTeamId === salesTeamId && r.date === date)
            );
        } else {
            //  Store only keys, NOT record
            updatedSelection = [
                ...selectedRecords,
                { salesTeamId, date }
            ];
        }

        this.setState({ selectedRecords: updatedSelection });
    };


    //Helper: to check if record is selected
    isRecordSelected = (salesTeamId, date) => {
        const { selectedRecords } = this.state;
        return selectedRecords.some(
            (r) => r.salesTeamId == salesTeamId && r.date == date
        );
    };

    getDurationData = (salesTeamId, date) => {
        const { matrixData } = this.state;
        const { salesTeamCheckInOut } = matrixData;

        const record =
            salesTeamCheckInOut.find(
                (item) => item.salesTeamId == salesTeamId && item.date == date
            ) || {};

        const formatTime = (timeStr) => (!timeStr ? "00:00" : timeStr.slice(0, 5));

        const checkInTime = formatTime(record?.checkInTime);
        const checkOutTime = formatTime(record?.checkOutTime);

        const calculateDuration = (inTime, outTime) => {
            if (!inTime || !outTime || inTime === "00:00" || outTime === "00:00") {
                return "00:00";
            }

            const checkIn = new Date(`1970-01-01T${inTime}`);
            const checkOut = new Date(`1970-01-01T${outTime}`);

            const diffMs = checkOut - checkIn;

            if (isNaN(diffMs) || diffMs < 0) return "00:00";

            const diffHrs = Math.floor(diffMs / 3600000);
            const diffMins = Math.floor((diffMs % 3600000) / 60000);

            return `${diffHrs.toString().padStart(2, "0")}:${diffMins
                .toString()
                .padStart(2, "0")}`;
        };


        const validateTimes = (field, newValue, updatedRecord) => {
            const inTime = field === "checkInTime" ? newValue : updatedRecord.checkInTime;
            const outTime = field === "checkOutTime" ? newValue : updatedRecord.checkOutTime;

            if (inTime && outTime && inTime > outTime) {
                return field === "checkInTime"
                    ? "Invalid Check-In Time"
                    : "Invalid Check-Out Time";
            }
            return null;
        };

        const handleTimeChange = (field, newValue) => {
            const updatedData = salesTeamCheckInOut.map((item) => {
                if (item.salesTeamId == salesTeamId && item.date == date) {
                    const updatedRecord = { ...item, [field]: newValue };
                    if (field === "checkInTime") updatedRecord.checkInEditable = true;
                    if (field === "checkOutTime") updatedRecord.checkOutEditable = true;

                    const errorMsg = validateTimes(field, newValue, updatedRecord);
                    if (errorMsg) {
                        updatedRecord.error = errorMsg;
                        updatedRecord.duration = "00:00";
                    } else {
                        updatedRecord.error = null;
                        if (updatedRecord.checkInTime && updatedRecord.checkOutTime) {
                            updatedRecord.duration = calculateDuration(
                                updatedRecord.checkInTime,
                                updatedRecord.checkOutTime
                            );
                        }
                    }
                    return updatedRecord;
                }
                return item;
            });

            this.setState({
                matrixData: { ...matrixData, salesTeamCheckInOut: updatedData },
            });
        };

        const displayDuration =
            record?.duration ||
            (checkInTime && checkOutTime
                ? calculateDuration(checkInTime, checkOutTime)
                : "00:00");

        const isCheckInEditable = record?.checkInEditable || !record?.checkInTime;
        const isCheckOutEditable = record?.checkOutEditable || !record?.checkOutTime;
        const isSelected = this.isRecordSelected(salesTeamId, date);
        const isCheckboxDisabled = record?.flag == 3;

        // --- Styles ---
        const containerStyle = {
            position: "relative",
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            gap: "8px",
            padding: "10px",
            width: "auto",
            height: "100%",
            boxSizing: "border-box",
            transition: "background 0.2s ease-in-out",
        };


        const checkboxStyle = {
            cursor: isCheckboxDisabled ? "not-allowed" : "pointer",
            transform: "scale(1.5)",
            width: "12px",
            height: "12px",
        };

        const rowStyle = {
            display: "flex",
            alignItems: "center",
            gap: "10px",
            width: "100%",
            flexDirection: "row",
        };

        const inputStyle = (isDisabled, isError) => ({
            padding: "6px 10px",
            borderRadius: "6px",
            border: `1px solid ${isError ? "red" : "#ccc"}`,
            minWidth: "120px",
            textAlign: "center",
            background: isDisabled ? "#eee" : "#fff",
            color: isError ? "red" : isDisabled ? "#666" : "#000",
            cursor: isDisabled ? "not-allowed" : "pointer",
            transition: "all 0.2s ease-in-out",
        });

        const labelStyle = {
            fontWeight: 450,
            color: "#333",
            fontSize: "13px",
            minWidth: "90px",
        };

        const errorStyle = {
            color: "red",
            fontSize: "12px",
            marginTop: "4px",
            textAlign: "center",
            fontWeight: 450,
        };

        return (
            <div style={containerStyle}>
                {/*Checkbox for selection */}
                <Tooltip
                    title={isCheckboxDisabled? youAreOnApprovedLeaveMsg : ""}
                    placement="top"
                    disableHoverListener={!isCheckboxDisabled}
                    disableFocusListener={!isCheckboxDisabled}
                    disableTouchListener={!isCheckboxDisabled}
                >
                    <span style={{ position: "absolute", top: "5px", left: "5px", display: "inline-flex" }}>
                        <input
                            type="checkbox"
                            checked={isSelected}
                            onChange={() => this.toggleRecordSelection(salesTeamId, date)}
                            style={checkboxStyle}
                            disabled={isCheckboxDisabled}
                        />
                    </span>
                </Tooltip>

                <div style={rowStyle}>
                    <span style={labelStyle}>Check In:</span>
                    <input
                        type="time"
                        value={checkInTime}
                        disabled={!isCheckInEditable}
                        onChange={(e) =>
                            handleTimeChange("checkInTime", e.target.value)
                        }
                        style={inputStyle(
                            !isCheckInEditable,
                            record?.error?.includes("Check-In")
                        )}
                    />
                </div>

                <div style={rowStyle}>
                    <span style={labelStyle}>Check Out:</span>
                    <input
                        type="time"
                        value={checkOutTime}
                        disabled={!isCheckOutEditable}
                        onChange={(e) =>
                            handleTimeChange("checkOutTime", e.target.value)
                        }
                        style={inputStyle(
                            !isCheckOutEditable,
                            record?.error?.includes("Check-Out")
                        )}
                    />
                </div>

                <div style={rowStyle}>
                    <span style={labelStyle}>Duration:</span>
                    <span
                        style={{
                            background: "#e9ecef",
                            borderRadius: "6px",
                            padding: "6px 10px",
                            fontWeight: "500",
                            minWidth: "100px",
                            textAlign: "center",
                        }}
                    >
                        {displayDuration} Hrs
                    </span>
                </div>

                {record?.error && <div style={errorStyle}>{record.error}</div>}
            </div>
        );
    };

    clickSubmitHandler = async () => {
        const { selectedRecords, latitute, longitute, matrixData } = this.state;
        const { showNotification, showLoador } = this.props;
        const { salesTeamCheckInOut } = matrixData;


        const finalSelectedRecords = salesTeamCheckInOut.filter((row) =>
            selectedRecords.some(
                (r) => r.salesTeamId === row.salesTeamId && r.date === row.date
            )
        );


        if (finalSelectedRecords.length == 0) {
            return showNotification({ msg: checkedListEmptyMsg, severity: "error" });
        }

        const checkOutTimeErrorData = finalSelectedRecords.filter(
            (row) => row.checkOutTime === null
        );


        if (checkOutTimeErrorData.length > 0) {
            const message = checkOutTimeErrorData
                .map((row) => `${row.employeeCode} (${row.date})`)
                .join(", ");

            showNotification({
                msg: `Please select check-out time for: ${message}`,
                severity: "error",
            });
            return;
        }


        const normalizeTime = (timeStr) => {
            if (!timeStr) return null;
            return timeStr.length === 5 ? timeStr + ":00" : timeStr;
        };


        let address = null;
        if (latitute && longitute) {
            try {
                showLoador({ loador: true });

                const apiUrl = `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitute},${longitute}&key=${"AIzaSyDvKXkZ-S03qxR-8b8HLnCOKr36eYRxC2k"}`;

                const response = await fetch(apiUrl);
                const data = await response.json();

                if (data && data.status === "OK" && data.results && data.results.length > 0) {
                    address = data.results[0].formatted_address;
                    console.log("fetchedAddress", address);
                } else {
                    console.error("Geocode response error:", data && data.status);
                    address = null;
                }
            } catch (err) {
                console.error("Geocode fetch error:", err);
                address = null;
            } finally {
                showLoador({ loador: false });
            }
        } else {
            return showNotification({ msg: pleaseAllowLocationMsg, severity: "error" });
        }

        const finalSaveList = finalSelectedRecords.map((dataObj) => {
            return {
                ...dataObj,
                startAddress: (dataObj.checkInLong === null && dataObj.checkInLat === null) ? address : null,
                endAddress: (dataObj.checkOutLong === null && dataObj.checkOutLat === null) ? address : null,
                checkInTime: dataObj.date + " " + normalizeTime(dataObj.checkInTime),
                checkOutTime: dataObj.date + " " + normalizeTime(dataObj.checkOutTime),
                checkInLong: dataObj.checkInLong !== null ? dataObj.checkInLong : longitute,
                checkInLat: dataObj.checkInLat !== null ? dataObj.checkInLat : latitute,
                checkOutLong: dataObj.checkOutLong !== null ? dataObj.checkOutLong : longitute,
                checkOutLat: dataObj.checkOutLat !== null ? dataObj.checkOutLat : latitute,
            }
        })

        this.onSave(finalSaveList);
    }

    clickDeleteHandler = async () => {
        const { selectedRecords } = this.state;
        const { showNotification } = this.props;

        if (selectedRecords.length == 0) {
            return showNotification({ msg: checkedListEmptyMsg, severity: "error" });
        }

        const deleteRecordList = selectedRecords.map((dataObj) => {
            return {
                salesTeamId: dataObj.salesTeamId !== null ? dataObj.salesTeamId : "",
                dmyDate: dataObj.date !== null ? dataObj.date : "",

            }
        });

        this.onDelete(deleteRecordList);
    }

    onSave = (dataToSave) => {
        const { showLoador, showNotification } = this.props;
        const { fromDate, toDate, salesTeamId } = this.state;

        let onSearchData = {
            fromDate: fromDate,
            toDate: toDate,
            salesTeamId: salesTeamId,
        }

        swal({
            title: "Are you sure?",
            text: saveWarningMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then((willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });
                apiPost({
                    url: endpoint.checkInOut + "/save-or-update-record",
                    postBody: dataToSave,
                }).then(async ({ success }) => {
                    showLoador({ loador: false });
                    if (success) {
                        showNotification({
                            msg: savemsg,
                        });
                        await this.onSearch(onSearchData);
                    } else {
                        showNotification({
                            msg: saveFailedMsg,
                            severity: "error",
                        });
                    }
                });
            }
        });

    }

    onDelete = (dataToDelete) => {
        const { showLoador, showNotification } = this.props;
        const { fromDate, toDate, salesTeamId } = this.state;

        let onSearchData = {
            fromDate: fromDate,
            toDate: toDate,
            salesTeamId: salesTeamId,
        }

        swal({
            title: "Are you sure?",
            text: deleteWarningMsg,
            icon: "warning",
            buttons: true,
            dangerMode: true,
        }).then(async (willDelete) => {
            if (willDelete) {
                showLoador({ loador: true });

                await apiPost({
                    url: endpoint.checkInOut + "/delete-check-in-out-records",
                    postBody: dataToDelete,
                }).then(async ({ data, success }) => {
                    if (data.data.statusCode == 200) {
                        showNotification({
                            msg: deletemsg,
                        });
                        await this.onSearch(onSearchData);
                    } else {
                        showNotification({
                            msg: data.data.error ? data.data.message : serverMsg,
                            severity: "error",
                        });
                    }
                });

                showLoador({ loador: false });
            }
        });

    }

    onSearchValue = (searchValue) => {
        this.setState({
            searchValue: searchValue,
        });
    };


    getFilteredTableData = (tableData) => {
        const { searchValue } = this.state;
        return tableData.filter((currentRow) => {
            let isValid = false;
            let salesTeamName =
                currentRow.name != null ? currentRow.name : "";
            let Prefix =
                currentRow.stockStakeHolderType !== null && currentRow.stockStakeHolderType.prefix !== null
                    ? currentRow.stockStakeHolderType.prefix : "";
            if (
                salesTeamName &&
                salesTeamName.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            if (
                Prefix &&
                Prefix.toString().toLowerCase().includes(searchValue.trim().toLowerCase())
            ) {
                isValid = true;
                return true;
            }
            return isValid;
        });
    };

    render() {
        const {
            dynamicMasterData,
            salesPersonList,
            matrixData,
        } = this.state;
        return (
            <>
                <Paper
                    sx={{
                        padding: 2,
                    }}
                    elevation={0}
                >
                    <DynamicFormWithoutSave
                        formPath={CheckInOutJson.formPath}
                        showPdfDownload={false}
                        showExcelDownload={false}
                        showBackToList={false}
                        dynamicMasterData={dynamicMasterData}
                        screenTitle={CheckInOutJson.screenTitle}
                        fieldMeta={CheckInOutJson.fieldMeta}
                        apiBaseURL={CheckInOutJson.apiBaseURL}
                        showSaveNextBtn={CheckInOutJson.showSaveNextBtn}
                        isEditURL={CheckInOutJson.isEditURL}
                        showSaveBtnMain={false}
                        showSaveBtn={true}
                        onSave={this.onSearch}
                        saveBtnText={"Search"}
                        showCancel={false}
                    />
                    <br />
                    {Object.keys(matrixData).length !== 0 && matrixData?.salesTeamList.length !== 0 && (
                        <>
                            <LandingScreenHeader
                                screenTitle={""}
                                showSearchBox={true}
                                showTable={true}
                                showFilter={false}
                                showPdfDownload={false}
                                showExcelDownload={false}
                                onSearch={this.onSearchValue}
                            />

                            <div
                                style={{
                                    overflowX: "auto",
                                    overflowY: "auto",
                                    maxHeight: "500px",
                                    position: "relative",
                                }}
                            >
                                <table
                                    style={{
                                        borderCollapse: "collapse",
                                        width: "100%",
                                        textAlign: "center",
                                    }}
                                >
                                    <thead
                                        style={{
                                            position: "sticky",
                                            top: 0,
                                            background: "#f3f3f3",
                                            zIndex: 3,
                                            boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                        }}
                                    >
                                        <tr>
                                            {/* Sticky First Column Header */}
                                            <th
                                                style={{
                                                    position: "sticky",
                                                    left: 0,
                                                    background: "#f3f3f3",
                                                    zIndex: 4,
                                                    border: "1px solid #ccc",
                                                    borderLeft: "2px solid #ccc", // 👈 ensures visible left edge
                                                    boxShadow: "2px 0 4px rgba(0,0,0,0.08)", // 👈 subtle visual separation
                                                    padding: "12px",
                                                    minWidth: "170px",
                                                    height: "40px",
                                                    fontWeight: "500",
                                                }}
                                            >
                                                Sales Team
                                            </th>

                                            {matrixData?.dates?.map((dateObj) => (
                                                <th
                                                    key={dateObj.date}
                                                    style={{
                                                        border: "1px solid #ccc",
                                                        padding: "12px",
                                                        minWidth: "120px",
                                                        height: "40px",
                                                        fontWeight: "500",
                                                        background: "#f3f3f3",
                                                    }}
                                                >
                                                    {dateObj.date}
                                                </th>
                                            ))}
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {this.getFilteredTableData(matrixData?.salesTeamList).map((team) => (
                                            <tr key={team.id}>
                                                {/* Sticky First Column Cell */}
                                                <td
                                                    style={{
                                                        position: "sticky",
                                                        left: 0,
                                                        background: "#fafafa",
                                                        zIndex: 2,
                                                        border: "1px solid #ccc",
                                                        borderLeft: "2px solid #ccc", // 👈 keeps left line visible
                                                        boxShadow: "2px 0 4px rgba(0,0,0,0.05)", // 👈 subtle separator shadow
                                                        padding: "12px",
                                                        fontWeight: "450",
                                                        height: "80px",
                                                        verticalAlign: "top",
                                                        textAlign: "left",
                                                    }}
                                                >
                                                    {team.name + " (" + team.stockStakeHolderType.prefix + ")"}
                                                </td>

                                                {matrixData?.dates?.map((dateObj) => (
                                                    <td
                                                        key={dateObj.date}
                                                        style={{
                                                            border: "1px solid #ccc",
                                                            padding: "12px",
                                                            height: "80px",
                                                            verticalAlign: "top",
                                                        }}
                                                    >
                                                        {this.getDurationData(team.id, dateObj.date)}
                                                    </td>
                                                ))}
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            </div>



                            <br />
                            <Grid
                                item
                                sm={12}
                                xs={12}
                                md={12}
                                lg={12}
                                container
                                justifyContent="flex-end"
                                gap={3}
                            >
                                <ButtonCompo
                                    sx={{
                                        bgcolor: "dodgerblue",
                                        color: "#fbff00",
                                    }}
                                    size="medium"
                                    type="button"
                                    variant="contained"
                                    name={"Delete Record"}
                                    onClick={this.clickDeleteHandler}
                                    fullWidth={false}
                                />

                                <ButtonCompo
                                    sx={{
                                        bgcolor: "dodgerblue",
                                        color: "#fbff00",
                                    }}
                                    size="medium"
                                    type="button"
                                    variant="contained"
                                    name={"Submit"}
                                    onClick={this.clickSubmitHandler}
                                    fullWidth={false}
                                />
                            </Grid>
                        </>
                    )}



                </Paper>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
    salesPersonList: state.salesExecutive,
});
const mapDispatchToProps = {
    getSalesExecutiveByUserType,
    showLoador,
    showNotification,
    getBelowSalesTeamList,
};
export default connect(mapStateToProps, mapDispatchToProps)(CheckInOut);
